import { skipToken } from "@reduxjs/toolkit/query";
import { useCallback, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  useGetVisitQuery,
  useUpdateVisitMutation,
} from "src/api/services/visitApi";
import { MatchParam } from "src/constants/matches";

export function useUpdateVisitMetadata() {
  const { visitId } = useParams<MatchParam<"VISIT_ID">>();
  const { data } = useGetVisitQuery(visitId ?? skipToken);
  const [updateVisit] = useUpdateVisitMutation();

  const metadataRef = useRef(data?.metadata);

  useEffect(() => {
    metadataRef.current = data?.metadata;
  }, [data?.metadata]);

  const update = useCallback(
    (newMetadata: Record<string, string | number | undefined>) => {
      if (visitId == null) return null;

      updateVisit({
        slug: visitId,
        data: {
          metadata: {
            ...data?.metadata,
            ...newMetadata,
          },
        },
      });
    },
    [updateVisit, visitId],
  );

  return { update };
}
